<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="telefones"
      :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      hide-default-footer
      sort-by="numero"
    >
      <template v-slot:no-data>
        Sem dados
      </template>
      <!-- action -->
      <template #[`item.actions`]="{ item }">
        <v-icon
          small
          @click="deleteItem(item)"
        >
          {{ icons.mdiDeleteOutline }}
        </v-icon>
      </template>
    </v-data-table>

    <!-- dialog -->
    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          Tem certeza de que quer apagar este contato?
        </v-card-title>
        <v-card-actions>
          <v-btn
            color="error"
            outlined
            @click="closeDelete"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="deleteItemConfirm"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiDeleteOutline } from '@mdi/js'

export default {
  model: {
    prop: 'telefones',
    event: 'update:telefones',
  },
  props: {
    telefones: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    dialog: false,
    dialogDelete: false,
    icons: {
      mdiDeleteOutline,
    },
    headers: [
      { text: 'Tipo', value: 'tipo' },
      { text: 'Número', value: 'numero' },
      { text: 'Ramal', value: 'ramal' },
      { text: 'Deletar', value: 'actions' },
    ],
    editedIndex: -1,
    defaultItem: {},
  }),

  watch: {
    // telefones() {
    //   const header = Object.keys(this.telefones)
    //   for (let index = 0; index < header.length; index++) {
    //     this.headers.push({ text: header[index], value: header[index] })
    //   }
    //   this.headers.push({ text: 'Deletar', value: 'actions' })
    // },
  },

  methods: {
    deleteItem(item) {
      this.editedIndex = this.telefones.indexOf(item)
      this.editedItem = { ...item }
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      this.telefones.splice(this.editedIndex, 1)
      this.$emit('update:telefones', this.telefones)
      this.closeDelete()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },
  },
}
</script>
